import { trackEvent } from 'lib/ui-analytics';
import { TRACKING_ACTION, TRACKING_INTERACTION, TRACKING_COMPARE, PROD_CATEGORY } from 'contexts/AnalyticsContext/Constants';
import { formatInteraction } from './utagExploreItineraryLinkClicked';

export const utagComparePageWatchlistAndSelectDateButton = ({ eventWatchlistButton, eventSelectDate, cruise, sailing, index, totalResults}) => {
    const eventTrigger = eventWatchlistButton ?? eventSelectDate;
    const { productEvent, interaction } = getProductEventAndInteraction(eventTrigger, cruise, totalResults, index);

    const event = {
        eventType: TRACKING_ACTION.INTERACTION,
        cruiseLength: cruise?.masterSailing?.itinerary?.totalNights,
        deembarkation_date: sailing?.endDate,
        departurePort: cruise?.masterSailing?.itinerary?.departurePort?.code,
        departureDate: sailing?.startDate,
        interaction,
        link_name: sailing?.bookingLink,
        pageName: TRACKING_COMPARE.COMPARE_PAGE,
        prodCategory: [PROD_CATEGORY.booking.toLowerCase()],
        prodCost: [Math.round(cruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value)],
        prodQuantity: [1],
        productEvent: [productEvent],
        product_id: `${PROD_CATEGORY.booking}-${cruise?.id}`,
        prodName: cruise?.masterSailing?.itinerary?.name,
        prodSku: [cruise?.masterSailing?.itinerary?.code],
        shipName: cruise?.masterSailing?.itinerary?.ship?.name,
        shipCode: cruise?.masterSailing?.itinerary?.ship?.code,
        siteSection: TRACKING_COMPARE.COMPARE_PAGE,
        cruiseSearchPrice: Math.round(
            cruise?.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value,
        ),
    }
    trackEvent(event);
}

const getProductEventAndInteraction = (event, cruise, totalResults, index) => {
    let productEvent = '';
    let interaction = '';
    switch (event) {
        case TRACKING_INTERACTION.FAVORITES_AND_WATCHLIST.CLICK_ADDED:
            productEvent = TRACKING_COMPARE.WATCHLIST_ADDED;
            interaction = formatInteraction( TRACKING_INTERACTION.COMPARE.WATCHLIST_ADDED,
                cruise, totalResults, index)
            break;
    
        case TRACKING_INTERACTION.FAVORITES_AND_WATCHLIST.CLICK_REMOVED:
            productEvent = TRACKING_COMPARE.WATCHLIST_REMOVED;
            interaction = formatInteraction( TRACKING_INTERACTION.COMPARE.WATCHLIST_REMOVED,
                cruise, totalResults, index)
            break;
    
        case TRACKING_COMPARE.SELECT_DATE:
            productEvent = TRACKING_COMPARE.SELECT_DATE;
            interaction = formatInteraction( TRACKING_INTERACTION.COMPARE.SELECT_DATE,
                cruise, totalResults, index)
            break;
    
        default:
            break;
    }
    return { productEvent, interaction };
}

